/* tslint:disable */
/* eslint-disable */
/**
 * Naviexpress Archive Search User API
 * API for Naviexpress Archive Search.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 文書アーカイブ
 * @export
 * @interface DocArchive
 */
export interface DocArchive {
    /**
     * ID
     * @type {string}
     * @memberof DocArchive
     */
    '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof DocArchive
     */
    'access_id'?: string;
    /**
     * 送信日
     * @type {string}
     * @memberof DocArchive
     */
    'send_date'?: string;
    /**
     * 発行日
     * @type {string}
     * @memberof DocArchive
     */
    'issued_date'?: string;
    /**
     * 文書名
     * @type {string}
     * @memberof DocArchive
     */
    'doc_name'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof DocArchive
     */
    'file_name'?: string;
    /**
     * ファイルサイズ
     * @type {number}
     * @memberof DocArchive
     */
    'file_size'?: number;
    /**
     * ファイルパス
     * @type {string}
     * @memberof DocArchive
     */
    'file_path'?: string;
    /**
     * 取引先
     * @type {string}
     * @memberof DocArchive
     */
    'customer'?: string;
    /**
     * 金額
     * @type {number}
     * @memberof DocArchive
     */
    'amount'?: number;
    /**
     * 検索キー１
     * @type {string}
     * @memberof DocArchive
     */
    'search_key_1'?: string;
    /**
     * 検索キー２
     * @type {string}
     * @memberof DocArchive
     */
    'search_key_2'?: string;
    /**
     * 検索キー３
     * @type {string}
     * @memberof DocArchive
     */
    'search_key_3'?: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof DocArchive
     */
    'create_dttm'?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof DocArchive
     */
    'update_dttm'?: string;
}
/**
 * ログプアーカイブ
 * @export
 * @interface LogResponseArchive
 */
export interface LogResponseArchive {
    // /**
    //  * ID
    //  * @type {string}
    //  * @memberof LogResponseArchive
    //  */
    // '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof LogResponseArchive
     */
    'access_id'?: string;
    /**
     * 作成日
     * @type {string}
     * @memberof LogResponseArchive
     */
    'create_date'?: string;
    // /**
    //  * 文書名
    //  * @type {string}
    //  * @memberof LogResponseArchive
    //  */
    // 'doc_name'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof LogResponseArchive
     */
    'file_name'?: string[];
    /**
     * ファイル名
     * @type {string}
     * @memberof LogResponseArchive
     */
    'file_name_line_break'?: string[];
    /**
     * ファイルサイズ
    //  * @type {number}
    //  * @memberof DocArchive
    //  */
    // 'file_size'?: number;
    /**
     * ファイルパス
     * @type {string}
     * @memberof LogResponseArchive
     */
    'file_path'?: string[];
}
/**
 * ダウンロード履歴
 * @export
 * @interface DownloadHistory
 */
export interface DownloadHistory {
    /**
     * ID
     * @type {string}
     * @memberof DownloadHistory
     */
    '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof DownloadHistory
     */
    'access_id'?: string;
    /**
     * 検索履歴ID
     * @type {string}
     * @memberof DownloadHistory
     */
    'search_id'?: string;
    /**
     * 結合ファイル名
     * @type {string}
     * @memberof DownloadHistory
     */
    'combine_file_name'?: string;
    /**
     * 結合ファイルサイズ
     * @type {number}
     * @memberof DownloadHistory
     */
    'combine_file_size'?: number;
    /**
     * 結合完了日時
     * @type {string}
     * @memberof DownloadHistory
     */
    'combine_dttm'?: string;
    /**
     * 結合ステータス
     * @type {string}
     * @memberof DownloadHistory
     */
    'combine_status'?: string;
    /**
     * ダウンロードステータス
     * @type {string}
     * @memberof DownloadHistory
     */
    'download_status'?: string;
    /**
     * 
     * @type {SearchHistory}
     * @memberof DownloadHistory
     */
    'search_history'?: SearchHistory;
    /**
     * 作成日時
     * @type {string}
     * @memberof DownloadHistory
     */
    'create_dttm'?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof DownloadHistory
     */
    'update_dttm'?: string;
}

/**
 * ダウンロードログ履歴
 * @export
 * @interface DownloadLogHistory
 */
export interface DownloadLogHistory {
    /**
     * ID
     * @type {string}
     * @memberof DownloadLogHistory
     */
    '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'access_id'?: string;
    /**
     * 検索履歴ID
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'search_id'?: string;
    /**
     * 結合ファイル名
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'combine_file_name'?: string;
    /**
     * 結合ファイルサイズ
     * @type {number}
     * @memberof DownloadLogHistory
     */
    'combine_file_size'?: number;
    /**
     * 結合完了日時
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'combine_dttm'?: string;
    /**
     * 結合ステータス
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'combine_status'?: string;
    /**
     * ダウンロードステータス
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'download_status'?: string;
    /**
     * 
     * @type {SearchLogHistory}
     * @memberof DownloadLogHistory
     */
    'search_log_history'?: SearchLogHistory;
    /**
     * 作成日時
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'create_dttm'?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof DownloadLogHistory
     */
    'update_dttm'?: string;
}

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * ログイン名
     * @type {string}
     * @memberof InlineObject
     */
    'username'?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof InlineObject
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 更新トークン
     * @type {string}
     * @memberof InlineObject1
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 更新トークン
     * @type {string}
     * @memberof InlineObject2
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 変更前パスワード
     * @type {string}
     * @memberof InlineObject3
     */
    'oldPassword'?: string;
    /**
     * 変更後パスワード
     * @type {string}
     * @memberof InlineObject3
     */
    'newPassword'?: string;
    /**
     * アクセストークン
     * @type {string}
     * @memberof InlineObject3
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * ログイン名
     * @type {string}
     * @memberof InlineObject4
     */
    'username'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof InlineObject4
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 検索履歴ID
     * @type {string}
     * @memberof InlineObject5
     */
    'search_id'?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * IDトークン
     * @type {string}
     * @memberof InlineResponse200
     */
    'idToken'?: string;
    /**
     * アクセストークン
     * @type {string}
     * @memberof InlineResponse200
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 署名付きURL
     * @type {string}
     * @memberof InlineResponse2001
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 検索履歴ID
     * @type {string}
     * @memberof InlineResponse2002
     */
    'search_id'?: string;
    /**
     * 検索結果一覧
     * @type {Array<DocArchive>}
     * @memberof InlineResponse2002
     */
    'archives'?: Array<DocArchive>;
}

/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 検索履歴ID
     * @type {string}
     * @memberof InlineResponse2003
     */
    'search_id'?: string;
    /**
     * 検索結果一覧
     * @type {Array<LogResponseArchive>}
     * @memberof InlineResponse2003
     */
    'logArchives'?: Array<LogResponseArchive>;
}

/**
 * ユーザ情報
 * @export
 * @interface Login
 */
export interface Login {
    /**
     * 名前
     * @type {string}
     * @memberof Login
     */
    'name'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof Login
     */
    'email'?: string;
    /**
     * IDトークン
     * @type {string}
     * @memberof Login
     */
    'idToken'?: string;
    /**
     * アクセストークン
     * @type {string}
     * @memberof Login
     */
    'accessToken'?: string;
    /**
     * 更新トークン
     * @type {string}
     * @memberof Login
     */
    'refreshToken'?: string;
}


/**
 * 検索履歴
 * @export
 * @interface SearchHistory
 */
export interface SearchHistory {
    /**
     * ID
     * @type {string}
     * @memberof SearchHistory
     */
    '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof SearchHistory
     */
    'access_id'?: string;
    /**
     * 検索日時
     * @type {string}
     * @memberof SearchHistory
     */
    'search_dttm'?: string;
    /**
     * 送信日_from
     * @type {string}
     * @memberof SearchHistory
     */
    'send_date_from'?: string;
    /**
     * 送信日_to
     * @type {string}
     * @memberof SearchHistory
     */
    'send_date_to'?: string;
    /**
     * 発行日_from
     * @type {string}
     * @memberof SearchHistory
     */
    'issued_date_from'?: string;
    /**
     * 発行日_to
     * @type {string}
     * @memberof SearchHistory
     */
    'issued_date_to'?: string;
    /**
     * 文書名
     * @type {string}
     * @memberof SearchHistory
     */
    'doc_name'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof SearchHistory
     */
    'file_name'?: string;
    /**
     * 取引先
     * @type {string}
     * @memberof SearchHistory
     */
    'customer'?: string;
    /**
     * 金額_from
     * @type {number}
     * @memberof SearchHistory
     */
    'amount_from'?: number;
    /**
     * 金額_to
     * @type {number}
     * @memberof SearchHistory
     */
    'amount_to'?: number;
    /**
     * 検索キー１
     * @type {string}
     * @memberof SearchHistory
     */
    'search_key_1'?: string;
    /**
     * 検索キー２
     * @type {string}
     * @memberof SearchHistory
     */
    'search_key_2'?: string;
    /**
     * 検索キー３
     * @type {string}
     * @memberof SearchHistory
     */
    'search_key_3'?: string;
}

/**
 * ログ検索履歴
 * @export
 * @interface SearchLogHistory
 */
export interface SearchLogHistory {
    /**
     * ID
     * @type {string}
     * @memberof SearchLogHistory
     */
    '_id'?: string;
    /**
     * アクセスID
     * @type {string}
     * @memberof SearchLogHistory
     */
    'access_id'?: string;
    /**
     * 検索日時
     * @type {string}
     * @memberof SearchLogHistory
     */
    'search_dttm'?: string;
    /**
     * 作成日_from
     * @type {string}
     * @memberof SearchLogHistory
     */
    'create_date_from'?: string;
    /**
     * 作成日_to
     * @type {string}
     * @memberof SearchLogHistory
     */
    'create_date_to'?: string;
  
}


/**
 * ArchiveApi - axios parameter creator
 * @export
 */
export const ArchiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 文書アーカイブを取得するURLを返す。
         * @summary 文書アーカイブダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchiveUrl: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getArchiveUrl', 'id', id)
            const localVarPath = `/api/archives/{id}/url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文書アーカイブ履歴を検索する。
         * @summary 文書アーカイブ検索
         * @param {SearchHistory} searchHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchives: async (searchHistory: SearchHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchHistory' is not null or undefined
            assertParamExists('searchArchives', 'searchHistory', searchHistory)
            const localVarPath = `/api/archives/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログアーカイブ履歴を検索する。
         * @summary 文書アーカイブ検索
         * @param {SearchLogHistory} searchLogHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLogArchives: async (searchLogHistory: SearchLogHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchLogHistory' is not null or undefined
            assertParamExists('searchLogArchives', 'searchLogHistory', searchLogHistory)
            const localVarPath = `/api/archiveslog/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchLogHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文書アーカイブを更新する。
         * @summary 文書アーカイブ更新
         * @param {string} id オブジェクトID
         * @param {DocArchive} docArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchive: async (id: string, docArchive: DocArchive, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateArchive', 'id', id)
            // verify required parameter 'docArchive' is not null or undefined
            assertParamExists('updateArchive', 'docArchive', docArchive)
            const localVarPath = `/api/archives/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(docArchive, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArchiveApi - functional programming interface
 * @export
 */
export const ArchiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArchiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 文書アーカイブを取得するURLを返す。
         * @summary 文書アーカイブダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchiveUrl(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchiveUrl(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 文書アーカイブ履歴を検索する。
         * @summary 文書アーカイブ検索
         * @param {SearchHistory} searchHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchArchives(searchHistory: SearchHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchArchives(searchHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログアーカイブ履歴を検索する。
         * @summary 文書アーカイブ検索
         * @param {SearchLogHistory} searchLogHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLogArchives(searchLogHistory: SearchLogHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLogArchives(searchLogHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },

        
        /**
         * 文書アーカイブを更新する。
         * @summary 文書アーカイブ更新
         * @param {string} id オブジェクトID
         * @param {DocArchive} docArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchive(id: string, docArchive: DocArchive, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchive(id, docArchive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ArchiveApi - factory interface
 * @export
 */
export const ArchiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArchiveApiFp(configuration)
    return {
        /**
         * 文書アーカイブを取得するURLを返す。
         * @summary 文書アーカイブダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchiveUrl(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.getArchiveUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 文書アーカイブ履歴を検索する。
         * @summary 文書アーカイブ検索
         * @param {SearchHistory} searchHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchives(searchHistory: SearchHistory, options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.searchArchives(searchHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 文書アーカイブを更新する。
         * @summary 文書アーカイブ更新
         * @param {string} id オブジェクトID
         * @param {DocArchive} docArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchive(id: string, docArchive: DocArchive, options?: any): AxiosPromise<void> {
            return localVarFp.updateArchive(id, docArchive, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArchiveApi - object-oriented interface
 * @export
 * @class ArchiveApi
 * @extends {BaseAPI}
 */
export class ArchiveApi extends BaseAPI {
    /**
     * 文書アーカイブを取得するURLを返す。
     * @summary 文書アーカイブダウンロードURL取得
     * @param {string} id オブジェクトID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArchiveApi
     */
    public getArchiveUrl(id: string, options?: AxiosRequestConfig) {
        return ArchiveApiFp(this.configuration).getArchiveUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 文書アーカイブ履歴を検索する。
     * @summary 文書アーカイブ検索
     * @param {SearchHistory} searchHistory 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArchiveApi
     */
    public searchArchives(searchHistory: SearchHistory, options?: AxiosRequestConfig) {
        return ArchiveApiFp(this.configuration).searchArchives(searchHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログアーカイブ履歴を検索する。
     * @summary ログアーカイブ検索
     * @param {SearchLogHistory} searchLogHistory 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArchiveApi
     */
        public searchLogArchives(searchLogHistory: SearchLogHistory, options?: AxiosRequestConfig) {
            return ArchiveApiFp(this.configuration).searchLogArchives(searchLogHistory, options).then((request) => request(this.axios, this.basePath));
        }

    /**
     * 文書アーカイブを更新する。
     * @summary 文書アーカイブ更新
     * @param {string} id オブジェクトID
     * @param {DocArchive} docArchive 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArchiveApi
     */
    public updateArchive(id: string, docArchive: DocArchive, options?: AxiosRequestConfig) {
        return ArchiveApiFp(this.configuration).updateArchive(id, docArchive, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ダウンロードするための署名付きURLを返す。
         * @summary 署名付きダウンロードURL取得
         * @param {string} path パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrl: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getSignedUrl', 'path', path)
            const localVarPath = `/api/common/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonApiAxiosParamCreator(configuration)
    return {
        /**
         * ダウンロードするための署名付きURLを返す。
         * @summary 署名付きダウンロードURL取得
         * @param {string} path パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignedUrl(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignedUrl(path, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonApiFp(configuration)
    return {
        /**
         * ダウンロードするための署名付きURLを返す。
         * @summary 署名付きダウンロードURL取得
         * @param {string} path パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrl(path: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.getSignedUrl(path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * ダウンロードするための署名付きURLを返す。
     * @summary 署名付きダウンロードURL取得
     * @param {string} path パス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public getSignedUrl(path: string, options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).getSignedUrl(path, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DownloadApi - axios parameter creator
 * @export
 */
export const DownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ダウンロード履歴を追加する。
         * @summary ダウンロード履歴追加
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownload: async (inlineObject5: InlineObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject5' is not null or undefined
            assertParamExists('createDownload', 'inlineObject5', inlineObject5)
            const localVarPath = `/api/downloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ダウンロード履歴を追加する。
         * @summary ダウンロード履歴追加
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownloadLog: async (inlineObject5: InlineObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject5' is not null or undefined
            assertParamExists('createDownloadLog', 'inlineObject5', inlineObject5)
            const localVarPath = `/api/downloadslog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 結合ファイルを取得するURLを返す。
         * @summary 結合ファイルダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDownloadUrl', 'id', id)
            const localVarPath = `/api/downloads/{id}/url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 結合ログファイルを取得するURLを返す。
         * @summary 結合ファイルダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadLogUrl: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDownloadLogUrl', 'id', id)
            const localVarPath = `/api/downloadslog/{id}/url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         * ダウンロード履歴の一覧を返す。
         * @summary ダウンロード履歴一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloads: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/downloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ダウンロードログ履歴の一覧を返す。
         * @summary ダウンロード履歴一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadslog: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/downloadslog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

                const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
 
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
    
};

/**
 * DownloadApi - functional programming interface
 * @export
 */
export const DownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * ダウンロード履歴を追加する。
         * @summary ダウンロード履歴追加
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDownload(inlineObject5: InlineObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDownload(inlineObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
        * ダウンロード履歴を追加する。
        * @summary ダウンロード履歴追加
        * @param {InlineObject5} inlineObject5 
        * @param {*} [options] Override http request option.
        * @throws {RequiredError}
        */
       async createDownloadLog(inlineObject5: InlineObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
           const localVarAxiosArgs = await localVarAxiosParamCreator.createDownloadLog(inlineObject5, options);
           return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
       },

        /**
         * 結合ファイルを取得するURLを返す。
         * @summary 結合ファイルダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadUrl(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUrl(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 結合ファイルを取得するURLを返す。
         * @summary 結合ファイルダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadLogUrl(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadLogUrl(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ダウンロード履歴の一覧を返す。
         * @summary ダウンロード履歴一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloads(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DownloadHistory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloads(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ダウンロード履歴の一覧を返す。
         * @summary ダウンロード履歴一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadslog(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DownloadHistory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadslog(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
                },
    }
};

/**
 * DownloadApi - factory interface
 * @export
 */
export const DownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadApiFp(configuration)
    return {
        /**
         * ダウンロード履歴を追加する。
         * @summary ダウンロード履歴追加
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDownload(inlineObject5: InlineObject5, options?: any): AxiosPromise<void> {
            return localVarFp.createDownload(inlineObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 結合ファイルを取得するURLを返す。
         * @summary 結合ファイルダウンロードURL取得
         * @param {string} id オブジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.getDownloadUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ダウンロード履歴の一覧を返す。
         * @summary ダウンロード履歴一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloads(options?: any): AxiosPromise<Array<DownloadHistory>> {
            return localVarFp.getDownloads(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadApi - object-oriented interface
 * @export
 * @class DownloadApi
 * @extends {BaseAPI}
 */
export class DownloadApi extends BaseAPI {
    /**
     * ダウンロード履歴を追加する。
     * @summary ダウンロード履歴追加
     * @param {InlineObject5} inlineObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    public createDownload(inlineObject5: InlineObject5, options?: AxiosRequestConfig) {
        return DownloadApiFp(this.configuration).createDownload(inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ダウンロードログ履歴を追加する。
     * @summary ダウンロード履歴追加
     * @param {InlineObject5} inlineObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
        public createDownloadLog(inlineObject5: InlineObject5, options?: AxiosRequestConfig) {
            return DownloadApiFp(this.configuration).createDownloadLog(inlineObject5, options).then((request) => request(this.axios, this.basePath));
        }

    /**
     * 結合ファイルを取得するURLを返す。
     * @summary 結合ファイルダウンロードURL取得
     * @param {string} id オブジェクトID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    public getDownloadUrl(id: string, options?: AxiosRequestConfig) {
        return DownloadApiFp(this.configuration).getDownloadUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 結合ファイルを取得するURLを返す。
     * @summary 結合ファイルダウンロードURL取得
     * @param {string} id オブジェクトID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
        public getDownloadLogUrl(id: string, options?: AxiosRequestConfig) {
            return DownloadApiFp(this.configuration).getDownloadLogUrl(id, options).then((request) => request(this.axios, this.basePath));
        }

    /**
     * ダウンロード履歴の一覧を返す。
     * @summary ダウンロード履歴一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    public getDownloads(options?: AxiosRequestConfig) {
        return DownloadApiFp(this.configuration).getDownloads(options).then((request) => request(this.axios, this.basePath));
    }

        /**
     * ダウンロードログ履歴の一覧を返す。
     * @summary ダウンロード履歴一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
        public getDownloadslog(options?: AxiosRequestConfig) {
            return DownloadApiFp(this.configuration).getDownloadslog(options).then((request) => request(this.axios, this.basePath));
        }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ログインユーザのパスワードを変更する。
         * @summary パスワード変更
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (inlineObject3: InlineObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject3' is not null or undefined
            assertParamExists('changePassword', 'inlineObject3', inlineObject3)
            const localVarPath = `/api/login/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン認証を行う。
         * @summary ユーザログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (inlineObject: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject' is not null or undefined
            assertParamExists('login', 'inlineObject', inlineObject)
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログアウトを行う。
         * @summary ユーザログアウト
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (inlineObject1: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject1' is not null or undefined
            assertParamExists('logout', 'inlineObject1', inlineObject1)
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証トークンの更新を行う。
         * @summary トークン更新
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (inlineObject2: InlineObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject2' is not null or undefined
            assertParamExists('refreshToken', 'inlineObject2', inlineObject2)
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインユーザのパスワードを再発行する。
         * @summary パスワード再発行
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissuePassword: async (inlineObject4: InlineObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject4' is not null or undefined
            assertParamExists('reissuePassword', 'inlineObject4', inlineObject4)
            const localVarPath = `/api/login/reissue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * ログインユーザのパスワードを変更する。
         * @summary パスワード変更
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(inlineObject3: InlineObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(inlineObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン認証を行う。
         * @summary ユーザログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(inlineObject: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Login>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログアウトを行う。
         * @summary ユーザログアウト
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(inlineObject1: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証トークンの更新を行う。
         * @summary トークン更新
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(inlineObject2: InlineObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(inlineObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインユーザのパスワードを再発行する。
         * @summary パスワード再発行
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reissuePassword(inlineObject4: InlineObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reissuePassword(inlineObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * ログインユーザのパスワードを変更する。
         * @summary パスワード変更
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inlineObject3: InlineObject3, options?: any): AxiosPromise<void> {
            return localVarFp.changePassword(inlineObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン認証を行う。
         * @summary ユーザログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(inlineObject: InlineObject, options?: any): AxiosPromise<Login> {
            return localVarFp.login(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * ログアウトを行う。
         * @summary ユーザログアウト
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(inlineObject1: InlineObject1, options?: any): AxiosPromise<void> {
            return localVarFp.logout(inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証トークンの更新を行う。
         * @summary トークン更新
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(inlineObject2: InlineObject2, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.refreshToken(inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * ログインユーザのパスワードを再発行する。
         * @summary パスワード再発行
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissuePassword(inlineObject4: InlineObject4, options?: any): AxiosPromise<void> {
            return localVarFp.reissuePassword(inlineObject4, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * ログインユーザのパスワードを変更する。
     * @summary パスワード変更
     * @param {InlineObject3} inlineObject3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public changePassword(inlineObject3: InlineObject3, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).changePassword(inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン認証を行う。
     * @summary ユーザログイン
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login(inlineObject: InlineObject, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).login(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログアウトを行う。
     * @summary ユーザログアウト
     * @param {InlineObject1} inlineObject1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public logout(inlineObject1: InlineObject1, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).logout(inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証トークンの更新を行う。
     * @summary トークン更新
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public refreshToken(inlineObject2: InlineObject2, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).refreshToken(inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインユーザのパスワードを再発行する。
     * @summary パスワード再発行
     * @param {InlineObject4} inlineObject4 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public reissuePassword(inlineObject4: InlineObject4, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).reissuePassword(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }
}


